const translationsEs = {
  'novotel': {
    'rates': {
      'roomRatesTitle': 'TARIFA DE HABITACIÓN',
      'dayRate': 'Tarifa del dia'
    }
  }
}

export default translationsEs



// WEBPACK FOOTER //
// ./src/tools/i18n/es.js